import React from 'react'

import Landing from './Landing'
import LoadingSpinner from '../landing/LoadingSpinner'
import Vehicle from '../vehicleDetails/Vehicle'
import Aftermarket from '../aftermarket/Aftermarket'
import History from '../history/History'
import ImageCapture from '../condition/ImageCapture'
import Condition from '../condition/Condition'
import Exterior from '../condition/Exterior'
import GlassAndWheels from '../condition/GlassAndWheels'
import Interior from '../condition/Interior'
import Mechanical from '../condition/Mechanical'
import Contact from '../contact/Contact'
import Loading from '../loading/Loading'
import Certificate from '../certificate/Certificate'
import Summary from '../review/Summary'
import {
  LandingPageNumber,
  OptionsPageNumber,
  AftermarketPageNumber,
  ImageCapturePageNumber,
  HistoryPageNumber,
  ExteriorPageNumber,
  GlassPageNumber,
  InteriorPageNumber,
  MechanicalPageNumber,
  ContactPageNumber,
  SummaryPageNumber,
  LoadingPageNumber,
  CertificatePageNumber,
} from '../../constants'

//if options page is removed then change all options page number references to vehicle page number
export default props => {
  const step = props.urlState.p
  let ICOComponent = Landing
  if (step > LandingPageNumber) {
    const { year, make, model, trim, vinResults, offer, prospectDocuments, experienceState } = props
    const { prospectResult } = experienceState
    if ((year && make && model && trim) || vinResults || offer || prospectResult) {
      ICOComponent = Vehicle
      if (step > OptionsPageNumber && step < CertificatePageNumber && prospectDocuments) {
        if (step === AftermarketPageNumber) ICOComponent = Aftermarket
        else if (step === HistoryPageNumber) ICOComponent = History
        else if (step === ImageCapturePageNumber) ICOComponent = ImageCapture
        else if (step === ExteriorPageNumber) ICOComponent = Condition
        else if (step === GlassPageNumber) ICOComponent = GlassAndWheels
        else if (step === InteriorPageNumber) ICOComponent = Interior
        else if (step === MechanicalPageNumber) ICOComponent = Mechanical
        else if (step === ContactPageNumber) ICOComponent = Contact
        else if (step === SummaryPageNumber) ICOComponent = Summary
        else if (step === LoadingPageNumber) ICOComponent = Loading
      } else if (step === CertificatePageNumber) ICOComponent = Certificate
    } else {
      ICOComponent = LoadingSpinner
    }
  }
  return <ICOComponent {...props} />
}
